module.exports = __webpack_public_path__ + "img/187w.997621c.jpg";